import '../css/app.css';
import './bootstrap';

import {createInertiaApp, router} from '@inertiajs/react';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {createRoot, hydrateRoot} from 'react-dom/client';

import {Provider} from "react-redux";
import {store} from "./app/store";
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

router.on('invalid', (event) => {
    if (event.detail.response.status === 419) {
        event.preventDefault();
        alert('Сессия истекла. Страница будет перезагружена.');
        window.location.reload();
    }
});

router.on('success', (event) => {
    const csrfToken = event.detail.page.props.csrf_token;
    if (csrfToken) {
        const meta = document.head.querySelector('meta[name="csrf-token"]');
        if (meta) {
            meta.content = csrfToken;
        }
    }
});

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST ?? window.location.hostname,
    wsPort: Number(import.meta.env.VITE_REVERB_PORT) || 8080,
    wssPort: Number(import.meta.env.VITE_REVERB_PORT) || 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
});

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.jsx`,
            import.meta.glob('./Pages/**/*.jsx'),
        ),
    setup({el, App, props}) {
        if (import.meta.env.SSR) {
            hydrateRoot(el,
                <Provider store={store}>
                    <App {...props} />
                </Provider>
            );
            return;
        }
        createRoot(el).render(
            <Provider store={store}>
                <App {...props} />
            </Provider>
        );
    },
    progress: {
        color: '#4B5563',
    },
});
